import './index.css';
import 'typeface-roboto';
import 'react-pdf/dist/esm/Page/AnnotationLayer.css';
import 'react-pdf/dist/esm/Page/TextLayer.css';

import App from './App';
import { Provider } from 'react-redux';
import React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { store } from './app/store';
import { PostHogWrapper } from 'vendor/posthog/PostHogWrapper';
import { initDatadog } from 'vendor/datadog';
import { installStaleChunkReload } from 'app/utils/staleChunkReload';

installStaleChunkReload();

const datadogEnabled =
  import.meta.env.VITE_DATADOG_RUM_ENABLED === 'true' ||
  import.meta.env.VITE_DATADOG_LOGS_ENABLED === 'true';

if (datadogEnabled) {
  initDatadog();
}

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <PostHogWrapper>
      <Provider store={store}>
        <App />
      </Provider>
    </PostHogWrapper>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
